<template>
	<div class="bg-dark">
		<div class="row">
			<div style="backgroundColor:#1D1D1E" class="col-6 text-center">
				<h1 class="mt-5" style="color:white;fontFamily: 'gorditaregular';">
					Want to take your business to <br />
					the next level? Try Socialytics
				</h1>
				<img
					src="resources/images/social_signin.png"
					width="100%"
					alt="Social Logo"
					style="marginTop:-40px;"
				/>
			</div>
			<div class="mt-auto mb-auto ml-auto mr-auto text-center col-6">
				<div style="width:80%" class="ml-auto mr-auto">
					<div class="d-flex justify-content-between align-items-center">
						<div class="logo mt-5">
							<img src="resources/images/social_4.png" alt="" width="90" />
						</div>
					</div>
					<br />
					<br />
					<div
						class="text-light font-size-50 mb-5 text-left"
						style="fontFamily: 'gorditamedium';lineHeight: 1.09em;"
					>
						Hi buddy, welcome back!
					</div>
					<a-form
						class="mb-4 mr-auto ml-auto"
						:form="form"
						@submit="handleSubmit"
					>
						<a-form-item style="textAlign:left">
							<label style="color:white;">Email</label>
							<a-input
								class="input-group-meta email-input"
								size="large"
								placeholder="name@domain.com"
								v-decorator="[
									'email',
									{
										initialValue: '',
										rules: [
											{
												required: true,
												message: 'Enter your email',
												type: 'email',
											},
										],
									},
								]"
							/>
						</a-form-item>
						<a-form-item style="textAlign:left">
							<label style="color:white;">Password</label>
							<a-input-password
								class="password-input"
								size="large"
								type="password"
								placeholder="Enter Password"
								v-decorator="[
									'password',
									{
										initialValue: '',
										rules: [
											{
												required: true,
												message: 'Enter your password, 6 character at least',
												min: 6,
											},
										],
									},
								]"
							/>
						</a-form-item>
						<br />
						<a-button
							type="primary"
							htmlType="submit"
							size="large"
							class="text-center btn-two w-100 lg-mt-30 lg-mb-30"
							style="fontFamily: 'gorditaregular';"
							>Log in</a-button
						>
					</a-form>
					<img
						class="mt-5"
						src="resources/images/positivessl_trust_seal_lg.png"
						alt="SSL Trust"
					/>
					<div class="mt-auto pb-5 pt-5">
						<div class="text-gray-6 text-center">
							© 2019 Mediatec. All rights reserved.
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as ACTIONS from '../../../../store/actions'

export default {
	name: 'AirLogin',
	data: function() {
		return {
			form: this.$form.createForm(this),
			loading: true,
		}
	},
	created() {
		this.loading = false
	},
	methods: {
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFields((err, values) => {
				if (!err) {
					this.$nprogress.start()
					this.$store
						.dispatch(ACTIONS.USER.LOGIN, {
							email: values.email,
							password: values.password,
						})
						.then(res => {
							this.$notification.success(
								'Logged In',
								`Welcome ${res.user.firstname + ' ' + res.user.lastname}`,
							)
						})
						.catch(err => {
							if (err.statusCode === 404) {
								this.$notification.warning('Whoops', err.message)
							} else {
								this.$notification.error('Warning', err.message)
							}
						})
						.finally(() => {
							this.$nprogress.done()
						})
				}
			})
		},
	},
}
</script>
<style>
.btn-two {
	font-size: 17px;
	color: #fff;
	padding: 0 33px;
	border: 1px solid #fff;
	border-radius: 30px;
	box-shadow: 0px 15px 30px rgba(0, 38, 95, 0.02);
	transition: all 0.3s ease-in-out;
	background: transparent;
}
.btn-two:hover {
	background: #1b55e3;
	border-color: #1b55e3;
}
.password-input .ant-input {
	background: transparent !important;
	width: 100%;
	height: 50px;
	font-size: 17px;
	border: 2px solid rgba(255, 255, 255, 0.8);
	padding: 0 52px 0 25px;
	border-radius: 8px;
	color: white;
}
.password-input .ant-input:focus {
	background: white !important;
	color: black;
}
.input-group-meta {
	width: 100%;
	height: 50px;
	font-size: 17px;
	border: 2px solid rgba(255, 255, 255, 0.8);
	padding: 0 52px 0 25px;
	background: transparent;
	border-radius: 8px;
}
.email-input:focus {
	color: black;
	background: #fff;
}
::-webkit-scrollbar {
	width: 5px;
}
::-webkit-scrollbar-track {
	background: #fff;
}
::-webkit-scrollbar-thumb {
	background: #913bff;
	border-radius: 0;
}
@font-face {
	font-family: 'gorditabold';
	src: url('../fonts/gordita/gordita-bold-webfont.woff2') format('woff2'),
		url('../fonts/gordita/gordita-bold-webfont.woff') format('woff');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'gorditamedium';
	src: url('../fonts/gordita/gordita-medium-webfont.woff2') format('woff2'),
		url('../fonts/gordita/gordita-medium-webfont.woff') format('woff');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'gorditaregular';
	src: url('../fonts/gordita/gordita-regular-webfont.woff2') format('woff2'),
		url('../fonts/gordita/gordita-regular-webfont.woff') format('woff');
	font-weight: normal;
	font-style: normal;
}
</style>
<style lang="scss" module>
@import '@/components/system/Auth/style.module.scss';
</style>
